export class Country {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
